import {ENDPOINT_VERSIONS} from './_endpoint-versions';

export const TAGS_GET_ENDPOINT = `/${ENDPOINT_VERSIONS.V2}/tags`;

export const TAGS_CREATE_ENDPOINT = `/${ENDPOINT_VERSIONS.V2}/tags/create`;
